import { PATH_ROOT, PATH_SUBROOT } from '@/constants'

export function isRootOrSubroot(path: string) {
  return path === PATH_ROOT || path === PATH_SUBROOT
}
